import styled from "styled-components";
import {Flex} from "./flex";

export const FlexJustifyBetween = styled(Flex)`
    justify-content: space-between;
`;
